import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import React, { useEffect, useState } from 'react';
import { supabase } from '../database/database';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';
import { getUserDisplayName } from '../utils/profile';

function AppNavbar() {
    const [session, setSession] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        supabase.auth.getSession().then(({ data: { session } }) => {
            setSession(session);
        });
        const {
          data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
            setSession(session);
        });
        return () => subscription.unsubscribe();
    }, []);

    function handleSearch(event) {
        event.preventDefault();
        const query = searchTerm.trim();
        if (query) window.location.href = `/search?searchTerm=${encodeURIComponent(query)}`;
    }

    async function handleSignOut() {
        await supabase.auth.signOut();
        window.location.href = '/';
    }

    return (
        <Navbar expand="lg" className="site-navbar">
            <Container fluid>
                <Navbar.Brand href="/">
                    <span className="brand-mark" aria-hidden="true">B</span>
                    BlogSomething
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="blog-navigation" />
                <Navbar.Collapse id="blog-navigation">
                    <Nav className="ms-auto align-items-lg-center">
                        <Nav.Link href="/">Explore</Nav.Link>
                        <Nav.Link href="/videos">Videos</Nav.Link>
                        <Nav.Link href="/channels">Channels</Nav.Link>
                        <Nav.Link href="/create" className="create-link">Write a post</Nav.Link>
                        <NavDropdown title="More" id="blog-more-menu">
                            <NavDropdown.Item href="/about">About the community</NavDropdown.Item>
                            <NavDropdown.Item href="/support">Support</NavDropdown.Item>
                            {session ? (
                                <>
                                    <NavDropdown.Item href="/ai">AI writing ideas</NavDropdown.Item>
                                </>
                            ) : (
                                <NavDropdown.Item href="/auth">Log in or join</NavDropdown.Item>
                            )}
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="https://buymeacoffee.com/haroldas">Buy me a coffee</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                    <Form className="d-flex search-form" role="search" onSubmit={handleSearch}>
                        <Form.Control
                            type="search"
                            placeholder="Search posts"
                            aria-label="Search posts"
                            value={searchTerm}
                            onChange={(event) => setSearchTerm(event.target.value)}
                        />
                        <Button type="submit" variant="outline-success">Search</Button>
                    </Form>
                    {session ? (
                        <NavDropdown
                            className="profile-menu ms-lg-2"
                            align="end"
                            title={<span className="profile-menu-trigger" aria-label={`Profile menu for ${getUserDisplayName(session.user)}`}><FontAwesomeIcon icon={faCircleUser} aria-hidden="true" /><span className="profile-menu-name">{getUserDisplayName(session.user)}</span></span>}
                            id="profile-menu"
                        >
                            <NavDropdown.Header>{getUserDisplayName(session.user)}</NavDropdown.Header>
                            <NavDropdown.Item href="/profile">Profile &amp; stats</NavDropdown.Item>
                            <NavDropdown.Item href={`/author?id=${session.user.id}`}>My public page</NavDropdown.Item>
                            <NavDropdown.Item href="/channels">My channels</NavDropdown.Item>
                            <NavDropdown.Item href="/library">Subscriptions &amp; likes</NavDropdown.Item>
                            <NavDropdown.Item href="/settings">Settings</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item onClick={handleSignOut}>Sign out</NavDropdown.Item>
                        </NavDropdown>
                    ) : (
                        <Button className="ms-lg-2 mt-2 mt-lg-0" href="/auth" variant="primary">Join the community</Button>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default AppNavbar;